export default __webpack_public_path__ + "static/media/fa-light-300.6de34991.woff2";